<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="500px"
      :title="$l('dialog_title_sendContract') || '选择供应商联系人'"
      :close-on-click-modal="false"
      :before-close="close"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :scmCode="scmCode"
        :listAmzPurchaseCode="listAmzPurchaseCode"
        @close="close"
        @success="$emit('success')"
      />
      <span slot="footer">
        <el-button size="small" @click="close">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.send()">
          {{ $l('btn_send') || '发送' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    scmCode: { type: String, default: '' },
    listAmzPurchaseCode: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
